<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idaula" :options="datos" track-by="id" label="nombre"
        :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>

        <p class="text-primary"> <small>{{msg}}</small> </p>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,sede:{type:Object,required:true} },
    data(){
        return{
            datos: [],
            msg: '',
            modelo: {
                idaula: null,
            }
        }
    },
    watch:{
        'modelo.idaula': function(){this.model.idaula=this.modelo.idaula; },
        'sede.idsede': function(){ this.getDatos() },
    },
    methods:{
        async getDatos() {
            var vue = this;
            if( this.sede.idsede == null ) {
              window.console.error( "AULAS: no hay sede seleccionada" );
              return;
            }
            this.msg ='Buscando aulas.';
            var sql = gql`query{ getAulas(idsede:${this.sede.idsede.id}){ id,nombre,capacidad,estado,descripcion } }`;
            // window.console.log( sql );
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getAulas;
                vue.msg = vue.datos.length+' aulas.';
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getAulas' ) );
                vue.msg = vue.datos.length+' aulas.';
            })
        },
    },
    mounted(){
        this.msg = this.datos.length+' aulas.';
    }
}
</script>